module.exports = __webpack_public_path__ + "static/media/maanderzand.e5838e51.png";